import React from 'react';
import { Link } from 'react-router-dom';
import { FaFileAlt } from 'react-icons/fa';
import { Helmet } from 'react-helmet';

const Resources = () => {
  return (
    <>
    <Helmet>
      <title>Healthcare RCM Resources | Denial Codes | MDeRCM</title>
      <meta name="description" content="Free healthcare RCM resources, denial code guides and medical billing references for practices. CO denial codes explained." />
      <meta name="keywords" content="healthcare RCM resources, CO denial codes, medical billing resources, claim denial codes, revenue cycle management guides, medical billing reference" />
      <link rel="canonical" href="https://mdercm.com/resources/" />
      <meta property="og:title" content="Healthcare RCM Resources | Denial Codes | MDeRCM" />
      <meta property="og:description" content="Free healthcare revenue cycle management resources, denial code guides, and medical billing references." />
      <meta property="og:url" content="https://mdercm.com/resources/" />
      <meta property="og:type" content="website" />
    </Helmet>
    <div style={{ fontFamily: "'Poppins', sans-serif", padding: '60px 20px', maxWidth: '1200px', margin: '0 auto' }}>
      <h1 style={{ fontSize: '36px', fontWeight: '700', marginBottom: '40px' }}>Resources</h1>

      <div style={{
        border: '1px solid #D9EAF7',
        borderRadius: '10px',
        backgroundColor: '#F8FDFF',
        padding: '40px',
        maxWidth: '500px',
        boxShadow: '0 4px 12px rgba(0, 0, 0, 0.05)'
      }}>
        {/* Claim Icon Only */}
        <div style={{ marginBottom: '30px' }}>
          <FaFileAlt size={60} color="#F26522" />
        </div>

        {/* Updated Title */}
        <h2 style={{ fontSize: '28px', fontWeight: '700', marginBottom: '20px', color: '#001F2B' }}>
          Understanding CO Denial Codes
        </h2>

        {/* Rewritten Content */}
        <p style={{ fontSize: '16px', lineHeight: '1.6', color: '#333', marginBottom: '30px' }}>
          Gain clear insights into Contractual Obligation (CO) denial codes—why they’re issued, what they represent, and how they affect claim reimbursements.
          Learn to identify the root causes, analyze real-world scenarios, and apply proven strategies to prevent revenue loss and ensure faster claim resolution.
        </p>

        {/* Button */}
        <Link to="/resources/denial-codes" style={{
          display: 'inline-block',
          backgroundColor: '#F26522',
          color: '#fff',
          padding: '12px 28px',
          fontWeight: '700',
          fontSize: '15px',
          borderRadius: '30px',
          textDecoration: 'none'
        }}>
          VIEW LIST
        </Link>
      </div>
    </div>
    </>
  );
};

export default Resources;